<!--
 * @Description: 常见问题
-->
<template>
    <div class="must-know">
        <van-nav-bar
                left-text="返回"
                :title="title"
                @click-left="$comm.onClickLeft"
                v-show="$comm.titleShow()"  left-arrow
                fixed>
            <template #left>
                <span class="iconfont iconshang comm-rotate-270"></span>
                <span class="comm-return">返回</span>
            </template>
        </van-nav-bar>
        <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
        <van-tabs color="#1677FF" v-model="active" @change="onChange" sticky>
            <van-tab v-for="(tab, i) in tabs" :key="i" :title="tab.title">
                <div class="comm-seperator"></div>
                <!-- 用水百科 -->
                <div class="must-know-list" v-show="active===0">
                    <div v-for="(article, j) in articleList" :key="j">
                        <must-know-item :article="article" :title="tab.title"></must-know-item>
                    </div>
                </div>
                <!-- 服务承诺 -->
                <div v-show="active===1">
                    <pay-way :article="article" :title="title"></pay-way>
                </div>
                <div v-if="!loading&&articleList.length===0" style="text-align:center;">
                    <img style="width:200px;" :src="require('../../assets/images/no-data.png')">
                </div>
            </van-tab>
        </van-tabs>
        <div style="height:57px"></div>
        <home-bar></home-bar>
    </div>
</template>

<script>
    import MustKnowItem from '../guide/MustKnowItem'
    import HomeBar from '@/components/HomeBar.vue'
    import PayWay from '../guide/PayWay'
    export default {
        name: 'MustKnow',
        components: {
            MustKnowItem,
            HomeBar,
            PayWay
        },
        data() {
            return {
                active: 0,
                tabs: [
                    {
                        title: '用水百科'
                    },
                    {
                        title: '服务承诺'
                    }
                ],
                payWayContent: '',
                typeCode: 301,
                articleList: [],
                loading: false,
                article:{
                    ftitle:'',
                    fissuedate:'',
                    fhits:'',
                    fcontent:''
                },
                title:''
            }
        },
        mounted() {
            if (this.$route.query.active) {
                this.active = Number(this.$route.query.active)
            }
            this.onChange(this.active)
        },
        methods: {
            onChange(value) {
                if (value === 0) {
                    this.typeCode = 117 // 用水百科
                    this.title = '用水百科'
                } else if (value === 1) {
                    this.typeCode = 110 // 服务承诺
                    this.title = '服务承诺'
                } 
                this.getArticleData()
            },
            getArticleData() {
                let params = {
                    "typecode": this.typeCode,
                    "pagesize": 20,
                    "pageindex": 1
                }
                this.articleList = []
                this.$loading()
                this.loading = true
                this.$http.post(this.$api.getArticles, params).then(res => {
                    this.$clear()
                    this.loading = false
                    if (res.code === '000') {
                        this.articleList = res.data
                        // 服务承诺
                        if(this.active === 1&&this.articleList.length>0){
                            let params = {
                                "fid": this.articleList[0].fid,
                            }
                            this.$http.post(this.$api.getArticle, params).then(res => {
                                if (res.code==='000') {
                                    this.article = res.data
                                } else {
                                    this.$toast(res.msg)
                                }
                            })
                        }
                    } else {
                        this.$toast(res.msg)
                    }
                })
            },
        },
    }
</script>

<style lang="less" scoped>
    .must-know {
        .sales-net-list {
            padding: 0 16px;
        }
    }
</style>